import { nothing } from 'lit';

export function triStateButtonTemplate() {
  return nothing;
}
